module.exports = __webpack_public_path__ + "static/media/Grandpa.3b95c2af.jpg";